import React, { useState } from "react";
import { Link } from "react-router-dom";
import AdminNavbar from "../../modules/admin/AdminNavbar";
import ExamRoomAddModal from "./ExamRoomAddModal";
import { useSetRecoilState } from "recoil";
import {
  isExamRoomAddModalOpenState,
  isUrlCheckModalOpenState,
} from "../../../recoil/admin/examRoom";
import useExamRoomActions from "../../../api/hooks/admin/examRoom";
import { useQuery } from "@tanstack/react-query";
import { testRoomSnState } from "recoil/auth";
import AdminUrlModal from "./AdminUrlModal";
import useDebounceValue from "../../../api/hooks/debounce";
import Table from "../../modules/layout/Table";
import Banner from "../../modules/layout/Banner";
import { isTestroomNameState } from "../../../recoil/admin/examRoom";
// 관리자-MY홈-MY홈

const AdminHome = ({ isPageStep, setPageStep, setSearchTestRoom }) => {
  const setIsExamRoomModalOpen = useSetRecoilState(isExamRoomAddModalOpenState);
  const setUrlCheckModalOpen = useSetRecoilState(isUrlCheckModalOpenState);
  const { fetchExamRoomList } = useExamRoomActions();
  const [isGroupId, setGroupId] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const debouncedSearchQuery = useDebounceValue(searchKeyword, 500);
  const setTestRoomSn = useSetRecoilState(testRoomSnState);
  const setTestroomName = useSetRecoilState(isTestroomNameState);

  const {
    data: examRoomListData,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["fetchExamRoomList", debouncedSearchQuery],
    queryFn: () => fetchExamRoomList({ keyword: searchKeyword }),
    onSuccess: (res) => {
      console.log(res);
    },
  });

  const { getTotalRoomCnt } = useExamRoomActions();
  const { data: getTotalRoomCntList } = useQuery({
    queryKey: ["getTotalRoomCnt"],
    queryFn: () => getTotalRoomCnt({}),
  });

  const avgCalculation = (finish_tester, apply_tester) => {
    if (apply_tester === 0) {
      return "0%";
    } else {
      return String(((finish_tester / apply_tester) * 100).toFixed(0)) + "%";
    }
  };

  // console.log("확인지점1");
  // console.log(examRoomListData);

  return (
    <>
      <div>
        <link rel="stylesheet" type="text/css" href="/css/admin.css" />
        <AdminNavbar />
        <div className="admin_content">
          <div className="content-title">
            <p className="home">home</p>
          </div>
          <div className="content-cont">
            <div className="container">
              <div className="tab-title">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" type="button">
                      MY홈
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <Banner
                    className="grid-box"
                    properties={[
                      "시험실(진행)",
                      "시험실(종료)",
                      "시험 요청",
                      "응시 대기",
                      "응시완료/파기됨",
                      "응시 중단",
                    ]}
                    data={[
                      getTotalRoomCntList?.data.testroom_doing,
                      getTotalRoomCntList?.data.testroom_end,
                      getTotalRoomCntList?.data.applicator,
                      getTotalRoomCntList?.data?.testring,
                      `${getTotalRoomCntList?.data?.done || "-"}/0`,
                      null,
                    ]}
                    icons={[
                      "test-ing",
                      "test-end",
                      "request",
                      "wait",
                      "complete",
                      "stop",
                    ]}
                  />
                  <div className="flex filtering">
                    <div>
                      <button
                        type="button"
                        className="btn-custom b-btn plus"
                        onClick={() => setIsExamRoomModalOpen(true)}
                      >
                        시험실추가
                      </button>
                      {/* <button className="btn-custom w-btn exel-icon-b">
                        전체 시험현황(Exel)
                      </button> */}
                    </div>
                    <div>
                      <input
                        type="text"
                        className="search-input"
                        placeholder="시험실 제목"
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                      />
                      {/* <button
                        className="btn-custom b-btn input-btn"
                        onClick={() => refetch()}
                      >
                        검색
                      </button> */}
                    </div>
                  </div>
                  <div className="tableFixHead table-responsive">
                    <Table
                      isLoading={isLoading}
                      className="home-table"
                      header={[
                        "시험실 제목",
                        "시험실 상태",
                        "응시완료/요청",
                        "응시율",
                        "평가율",
                        "URL",
                      ]}
                    >
                      {/* {examRoomListData?.data?.test_room_list?.map(
                      (examRoom) => ( */}
                      {(Array.isArray(examRoomListData?.data)
                        ? examRoomListData?.data
                        : []
                      )?.map((examRoom) => (
                        <tr key={examRoom?.sn}>
                          <td className="text-align-left">
                            <Link
                              to=""
                              className="test-title-link"
                              onClick={() => {
                                setTestroomName(examRoom?.group_title);
                                setTestRoomSn(examRoom.sn);
                                setPageStep(1);
                              }}
                            >
                              {examRoom?.group_title}
                            </Link>
                          </td>
                          <td>{examRoom.done === false ? "진행중" : "종료"}</td>
                          <td>
                            {examRoom.finish_tester}/{examRoom.apply_tester}
                          </td>
                          {/*<td>33%</td>*/}
                          <td>
                            {avgCalculation(
                              Number(examRoom.finish_tester),
                              Number(examRoom.apply_tester)
                            )}
                          </td>
                          <td>
                            <div className="slidecontainer">
                              <input
                                type="range"
                                disabled
                                min="0"
                                max={examRoom.all_combo}
                                defaultValue={examRoom.finish_combo}
                                className="slider"
                                id="myRange"
                              />
                            </div>
                            <p className="range-text">
                              평가자: {examRoom.rater_count}명 평가완료 :{" "}
                              {examRoom.finish_combo}/{examRoom.all_combo} 건
                              완료
                            </p>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="url-modalbtn"
                              onClick={() => {
                                setGroupId(examRoom.group_uuid);
                                setUrlCheckModalOpen(true);
                              }}
                            ></button>
                          </td>
                        </tr>
                      ))}
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- 시험실 추가 모달 --> */}
        <ExamRoomAddModal />
        <AdminUrlModal isGroupId={isGroupId} />
      </div>
    </>
  );
};

export default AdminHome;
